import { z } from 'zod';

export const InputSchema = z.object({
    transactionId: z.number(),
});

export type CheckoutCallbackPaysafeInput = z.infer<typeof InputSchema>;

const Statuses = z.union([z.literal('failed'), z.literal('rejected'), z.literal('paid'), z.string()]);

export const SuccessResponseSchema = z.object({
    amount: z.number(),
    status: Statuses,
    currency: z.string(),
    createdAt: z.string(),
    merchantRefNum: z.string().optional().nullable(),
});

type TSuccessResponse = z.infer<typeof SuccessResponseSchema>;

export const ErrorResponseSchema = z.object({
    error: z.object({
        code: z.string().optional().nullable(),
        message: z.string().optional().nullable(),
    }),
});

export const TrpcErrorResponseSchema = z.object({
    code: z.string().optional().nullable(),
    message: z.string().optional().nullable(),
});

type TErrorResponse = z.infer<typeof TrpcErrorResponseSchema>;

export type TResponseType =
    | { responseStatus: 'success'; response: TSuccessResponse }
    | { responseStatus: 'error'; data: TErrorResponse };
